import React from 'react';
import ReactDOM from 'react-dom/client';
import TripPlanner from './TripPlanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<TripPlanner />);
